import React, { useEffect, useState } from 'react';
import { t } from 'i18n';

import Button from 'Components/Base/Button';

import presets from './presets';

import Option from './Option';
import DeleteDialog from './DeleteDialog';

const i18nOpts = { scope: 'care_plan_creators.check_in_templates.questions' };

const LikertScaleQuestion = ({
  checkInQuestionOptions,
  onChange,
  editing,
  maximumCount = 7,
}) => {
  const [selectedPresetName, setSelectedPresetName] = useState('');
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteResponseIndex, setDeleteResponseIndex] = useState(null);

  useEffect(() => {
    if (!checkInQuestionOptions?.length) {
      onChange({ target: { name: 'checkInQuestionOptions', value: [] } })
    }
  }, []);

  const formatResponseOption = ({ text, id, index }) => {
    return {
      type: 'ScaleBasedOption',
      id,
      data: {
        text,
        response: t('default_response', i18nOpts),
        index,
        order: index,
        score: index + 1,
      },
    };
  };

  const handleAddPresetResponseOptions = (value) => {
    setSelectedPresetName(value);

    const responseOptions = value === 'custom'
      // For 'custom' preset we're generating 3 empty options
      ? [{}, {}, {}]
      : presets.find(preset => preset.name === value)?.responseOptions.map((text, index) => formatResponseOption({ text, index }));

    onChange({
      target: {
        name: 'checkInQuestionOptions',
        value: responseOptions || [],
      }
    });
  }

  const handleAddResponseOption = () => {
    onChange({
      target: {
        name: 'checkInQuestionOptions',
        value: [...checkInQuestionOptions, {}],
      }
    });
  };

  const handleUpdateResponseOption = ({ text, index, id }) => {
    const newResponseOptions = [...checkInQuestionOptions];
    newResponseOptions[index] = formatResponseOption({ text, index, id });

    onChange({
      target: {
        name: 'checkInQuestionOptions',
        value: newResponseOptions,
      }
    });
  };

  const handleDeleteResponseOption = () => {
    onChange({
      target: {
        name: 'checkInQuestionOptions',
        value: [
          ...checkInQuestionOptions.slice(0, deleteResponseIndex),
          ...checkInQuestionOptions.slice(deleteResponseIndex + 1),
        ],
      }
    });
    setIsDeleteModalOpen(false);
  };

  return <>
    {!editing && (
      <select
        value={selectedPresetName}
        onChange={({ target: { value } }) => handleAddPresetResponseOptions(value)}
      >
        <option key="blank" value="">{t('blank', i18nOpts)}</option>
        {presets.map((preset, i) => {
          const { label, name } = preset;
          return (
            <option
              key={i}
              value={name}
            >
              {label}
            </option>
          );
        })}
        <option value="" disabled>----</option>
        <option value="custom">{t('likert_presets.custom', i18nOpts)}</option>
      </select>
    )}
    <ul className="likert_scale_options_container">
      {
        checkInQuestionOptions.map((responseOption, i) => {
          return <Option
            key={i}
            index={i}
            score={i + 1}
            text={responseOption?.data?.text || ''}
            setText={({ target: { value } }) => {
              handleUpdateResponseOption({ text: value, id: responseOption.id, index: i })
            }}
            editing={editing}
            setIsDeleteModalOpen={setIsDeleteModalOpen}
            setDeleteResponseIndex={setDeleteResponseIndex}
            canDelete={checkInQuestionOptions.length > 3}
          />
        })
      }
    </ul>
    {checkInQuestionOptions.length < maximumCount && !editing && selectedPresetName ? (
      <div className="multiple-choice-button">
        <Button
          onClick={handleAddResponseOption}
          className="btn btn--secondary"
          text={t('add_response', i18nOpts)}
        />
      </div>
    ) : null}
    <DeleteDialog
      isOpen={isDeleteModalOpen}
      handleDelete={handleDeleteResponseOption}
      closeModal={() => setIsDeleteModalOpen(false)}
    />
  </>;
};

export default LikertScaleQuestion;
